module.exports = __webpack_public_path__ + "static/media/google-play.846b602a.svg";